// Environment configuration with type safety
export const env = {
  API_URL: import.meta.env.VITE_API_URL as string,
  // 'preview' = a per-PR preview deployment (docs/PREVIEW_ENVIRONMENTS.md).
  APP_ENV: import.meta.env.VITE_APP_ENV as 'development' | 'staging' | 'production' | 'preview',
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL as string,
  SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY as string,
} as const;

/**
 * Google sign-in cannot work on a preview deployment: Google needs exact-match redirect URIs and
 * every preview has its own Supabase branch callback. Login and signup hide the button there.
 */
export const GOOGLE_SIGN_IN_AVAILABLE = env.APP_ENV !== 'preview';
